export const hasDuplicateEntitlements = (entitlements) => {
  const entitlementsSet = new Set();
  try {
    entitlements.forEach((entitlement) => {
      if (entitlementsSet.has(entitlement.name)) {
        throw Error('Duplicate entitlement');
      }
      entitlementsSet.add(entitlement.name);
    });
  } catch (e) {
    return true;
  }
  return false;
};
